import { gql } from 'graphql-request';

export const GenerateImportFailureUpload = gql`
  mutation GenerateImportFailureUpload($input: GenerateDirectUploadInput!) {
    generateDirectUpload(input: $input) {
      uploadUrl
      headers
      signedId
    }
  }
`;

export const ReportImportFailure = gql`
  mutation ReportImportFailure($input: ReportImportFailureInput!) {
    reportImportFailure(input: $input) {
      success
    }
  }
`;
